import React, { lazy } from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Michael T.',
    role: 'Competitive Youth Coach',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80',
    text: "I've been coaching for years, and prep time was always my biggest hurdle. This system gave me my weekends back. The drills are high-energy and easy to teach."
  }, {
    name: 'David M.',
    role: 'Basketball Academy Director',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=200&q=80',
    text: 'The Scouting Toolkit is a game-changer. We started winning the close games because I actually knew what to adjust. This pack is a must-have for any serious coach.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-227">
      <div className="max-w-5xl mx-auto" data-id="element-228">
        <div className="text-center mb-12" data-id="element-229">
          <div className="bg-bb-charcoal text-bb-cream font-bold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-230">
            What Coaches Are Saying
          </div>
          <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl md:text-5xl text-bb-charcoal leading-tight mb-4 tracking-tight" data-id="element-231">
            Trusted by coaches{' '}
            <span className="text-bb-orange" data-id="element-232">on the court</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-233">
          {testimonials.map((t, idx) => <div key={idx} className="bg-bb-cream rounded-2xl p-7 shadow-sm border border-bb-line hover:border-bb-orange/40 transition-colors flex flex-col" data-id="element-234">
              <div className="flex text-bb-orange mb-4" data-id="element-235">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-236" />)}
              </div>
              <p className="text-bb-slate leading-relaxed mb-6 flex-1 text-base" data-id="element-237">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-bb-line" data-id="element-238">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover ring-2 ring-bb-orange/30" loading="lazy" decoding="async" width="48" height="48" data-id="element-239" />
                <div data-id="element-240">
                  <p className="font-display font-semibold uppercase text-base text-bb-charcoal tracking-wide" data-id="element-241">
                    {t.name}
                  </p>
                  <p className="text-bb-slate text-xs" data-id="element-242">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}